import React, { useState } from 'react';
import { Col, notification, Table } from 'antd';
import { downloadDictionary } from '/react4xp/parts/admin-dictionary/actions';
import { ColumnsType } from 'antd/es/table';
import Button from 'mixins/ui/button/button';
import { localize } from 'mixins/helpers';

interface ColumnItem {
    title: string;
    dataIndex: string;
    render?: (item: any, row: any) => JSX.Element;
}

type Props = {
    translations: Record<string, string>;
    data: any;
    totalCount: number;
    columns: ColumnsType<ColumnItem>;
    isLoading: boolean;
    code: string;
    page: number;
    setPage: (page: number) => void;
    size: number;
    setSize: (size: number) => void;
};

const ReferenceBookList: React.FC<Props> = ({
    translations,
    code,
    data,
    totalCount,
    columns,
    isLoading,
    page,
    setPage,
    size,
    setSize,
}) => {
    const columnToShow = columns.map((column) => column?.dataIndex);
    const [loading, setLoading] = useState(false);

    const downloadingDictionary = () => {
        setLoading(true);

        downloadDictionary(
            {
                dictionaryCode: code,
                page: 0,
                size: 1000
            },
            {
                columnsToShow: columnToShow,
                filterParams: {},
            }
        ).then(({ data }) => {
            const filename = 'dictionary.xlsx';
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            notification.success({
                message: 'Справочник успешно скачан!',
                duration: 3,
            });
        }).finally(
            () => setLoading(false),
        );
    };

    const handlePageNumberChange = (page) => {
        setPage(page);
    };

    const handleSizeChange = (current, pageSize) => {
        setSize(pageSize);
    };

    return (
        <div className="reference-table">
            <Table
                className="table-bordered"
                rowClassName={'table-row-dark'}
                pagination={{
                    current: page,
                    pageSize: size,
                    total: totalCount - size,
                    showSizeChanger: true,
                    onChange: handlePageNumberChange,
                    onShowSizeChange: handleSizeChange,
                }}
                dataSource={data}
                columns={columns}
                loading={isLoading}
            />
            <Col
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginRight: 5,
                    marginBottom: 5,
                }}
            >
                <Button
                    type="primary"
                    color="white"
                    onClick={downloadingDictionary}
                    loading={loading}
                >
                    {localize('button.download', translations)}
                </Button>
            </Col>
        </div>
    );
};

export default ReferenceBookList;
